<template>
  <div>
    böaslkdjf
  </div>
</template>

<script>
export default {
  data: () => ({
    types: ['Places to Be', 'Places to See', 'Nomal das Ganze'],
    cards: ['Good', 'Best', 'Finest'],
  }),

  methods: {

  },
};
</script>
